import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';

interface FilingApprovalModalProps {
  isOpen: boolean;
  onClose: () => void;
  onApprove: () => void;
  isLoading: boolean;
}

export const FilingApprovalModal = ({
  isOpen,
  onClose,
  onApprove,
  isLoading,
}: FilingApprovalModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent preventCloseOnOutsideClick>
        <DialogHeader className="flex items-start flex-col gap-1">
          <DialogTitle>Approve filing</DialogTitle>
        </DialogHeader>

        <div className="p-6">
          <p className="txt-small-regular text-text-secondary">
            Are you sure you want to approve this filing? Once approved, it is
            finalized and locked.
          </p>
        </div>

        <DialogFooter>
          <div className="flex items-center justify-end w-full gap-2">
            <Button variant="secondary" size="sm" onClick={onClose}>
              Cancel
            </Button>
            <Button size="sm" onClick={onApprove} disabled={isLoading}>
              Approve filing
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
